import format from 'date-fns/format'
import parse from 'date-fns/parse'
import languages from '../data/languages'

export const nullToEmptyString = obj => Object.entries(obj).reduce((accumulator, [key, value]) => {
	accumulator[key] = value === null ? '' : value

	return accumulator
}, {})

export const prepareDay = (date, language = null) => {
	if (date) {
		if (!(date instanceof Date) && language) {
			date = parse(date, languages[language].day, new Date())
		}

		return format(date, 'yyyy-MM-dd')
	}

	return null
}

export const preparePrice = (priceStr) => {
	if (!priceStr) return null

	let normalizedStr = priceStr.toString()

	if (!normalizedStr.includes(',') && !normalizedStr.includes('.')) {
		normalizedStr += '00'
	}

	const number = normalizedStr.replace(',', '').replace('.', '')

	if (number.length === 1) {
		return Number(`${number}00`)
	}

	if (number.length === 2) {
		return Number(`${number}0`)
	}

	return Number(number)
}

export const centsToEuro = (cents, decimalSeparator = '.') => {
	const euros = (cents / 100).toFixed(2)

	if (decimalSeparator !== '.') {
		return euros.replace('.', decimalSeparator)
	}

	return euros
}


export const formatCurrencyValue = (value, decimalSeparator = '.') => {
	if (!value) return ''

	// Convert value to a valid number
	let numValue = value.replace(/,/g, '.')

	// Handle cases where value starts with decimal separator
	if (numValue.startsWith('.')) {
		numValue = '0' + numValue
	}

	const parsed = parseFloat(numValue)
	if (isNaN(parsed)) return ''

	// Format to 2 decimal places
	const result = parsed.toFixed(2)

	if (decimalSeparator !== '.') {
		return result.replace('.', decimalSeparator)
	}

	return result
}
